import {
    campaignReportingActions,
    campaignReportingThunks as defaultThunks,
    campaignReportingSelectors as defaultSelectors,
    campaignReportingReducer,
} from './CampaignReporting-slice';
import * as thunks from './CampaignReporting-thunks';
import * as selectors from './CampaignReporting-selectors';

const campaignReportingThunks = { ...defaultThunks, ...thunks };
const campaignReportingSelectors = { ...defaultSelectors, ...selectors };

export {
    campaignReportingSelectors,
    campaignReportingActions,
    campaignReportingThunks,
    campaignReportingReducer,
};
